// @ts-expect-error pngs are untyped modules
import TikTokHero from 'bender-url!../../../assets/images/tiktok_banner.png';
// @ts-expect-error jpgs are untyped modules
import BreezeMarketplaceHero from 'bender-url!../../../assets/images/breeze-marketplace.jpg';
// @ts-expect-error jpgs are untyped modules
import BreezeAssistantHero from 'bender-url!../../../assets/images/breeze-assistants.jpg';
// @ts-expect-error jpgs are untyped modules
import GeminiConnectorHero from 'bender-url!../../../assets/images/gemini-connector.jpg';
// @ts-expect-error jpgs are untyped modules
import NewAndUpdatedAppsHero from 'bender-url!../../../assets/images/new-and-updated-apps.png';
// @ts-expect-error jpgs are untyped modules
import SolutionsMarketplaceHero from 'bender-url!../../../assets/images/solutions-marketplace.png';
// @ts-expect-error jpgs are untyped modules
import G2Hero from 'bender-url!../../../assets/images/g2-banner.png';
import I18n from 'I18n';
import { useMemo } from 'react';
import { matchPath, useParams, useRouteMatch } from 'react-router-dom';
import { Paths } from '../../constants/paths';
const createHeroItem = (path, title, subtitle, buttonText, buttonUrl, options = {}, secondaryButtonText, secondaryButtonUrl) => Object.assign({
  path,
  title,
  subtitle,
  buttonText,
  buttonUrl,
  secondaryButtonText,
  secondaryButtonUrl
}, options);
const getHeroItems = () => [createHeroItem(Paths.HOME, I18n.text('marketplaceStorefront.hero.home.tiktok.title'), I18n.text('marketplaceStorefront.hero.home.tiktok.subheading'), I18n.text('marketplaceStorefront.hero.home.tiktok.buttonText'), 'https://ecosystem.hubspot.com/marketplace/listing/tiktok?utm_campaign=39860566-PLTFM%20%7C%20TikTok%20Joint%20Marketing&utm_source=HomeMarketplaceBanner', {
  imageUrl: TikTokHero
}), createHeroItem(Paths.HOME, I18n.text('marketplaceStorefront.hero.apps.g2.title'), I18n.text('marketplaceStorefront.hero.apps.g2.subheading'), I18n.text('marketplaceStorefront.hero.apps.g2.buttonText'), 'https://ecosystem.hubspot.com/marketplace/listing/g2?utm_campaign=39691128-PLTFM%20%7C%20G2%20Joint%20Marketing&utm_source=AppMarketplaceBanner', {
  imageUrl: G2Hero
}), createHeroItem(Paths.AGENTS, I18n.text('marketplaceStorefront.hero.agents.breezeAgents.title'), I18n.text('marketplaceStorefront.hero.agents.breezeAgents.subheading'), I18n.text('marketplaceStorefront.hero.agents.breezeAgents.buttonText'), 'https://ecosystem.hubspot.com/marketplace/breeze-agents/all', {
  imageUrl: BreezeMarketplaceHero,
  resultType: 'INTERNAL_LINK',
  slug: 'all-breeze-agents'
}), createHeroItem(Paths.AGENTS, I18n.text('marketplaceStorefront.hero.agents.breezeAssistant.title'), I18n.text('marketplaceStorefront.hero.agents.breezeAssistant.subheading'), I18n.text('marketplaceStorefront.hero.agents.breezeAssistant.buttonText'), 'https://knowledge.hubspot.com/ai-tools/use-copilot', {
  imageUrl: BreezeAssistantHero,
  openCopilot: true,
  slug: 'use-copilot',
  resultType: 'EXTERNAL_LINK'
}), createHeroItem(Paths.SOLUTIONS_PARTNERS, I18n.text('marketplaceStorefront.hero.solutions.title'), I18n.text('marketplaceStorefront.hero.solutions.subheading'), I18n.text('marketplaceStorefront.hero.solutions.findPartnerMatch.buttonText'), '', {
  imageUrl: SolutionsMarketplaceHero,
  openFindPartnerMatch: true
}, I18n.text('marketplaceStorefront.hero.solutions.secondaryButtonText'), 'https://ecosystem.hubspot.com/marketplace/solutions/all'), createHeroItem(Paths.APPS, I18n.text('marketplaceStorefront.hero.home.newAndUpdatedApps.title'), I18n.text('marketplaceStorefront.hero.home.newAndUpdatedApps.subheading'), I18n.text('marketplaceStorefront.hero.home.newAndUpdatedApps.buttonText'), 'https://ecosystem.hubspot.com/marketplace/featured/recently-updated-apps?utm_campaign=34258498-PLTFM%20MKTG%20%7C%20New%20and%20Updated%20apps%20%7C%204Q2025&utm_source=hero-banner', {
  imageUrl: NewAndUpdatedAppsHero
})];
const getAiEssentialsHeroItems = () => [createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.buttonText'), 'https://hubspot.com/ai-tools/claude-connector', {
  videoId: 194142541338,
  resultType: 'EXTERNAL_LINK',
  slug: 'claude-connector'
}), createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.buttonText'), 'https://hubspot.com/ai-tools/openai-connector', {
  videoId: 194140662919,
  resultType: 'EXTERNAL_LINK',
  slug: 'openai-connector'
}), createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.buttonText'), 'https://gemini.google.com/apps?utm_campaign=30392094-PLTFM%20MKTG%20%7C%20HubSpot%20Connector%20for%20Gemini&utm_source=marketplace-banner', {
  imageUrl: GeminiConnectorHero,
  resultType: 'EXTERNAL_LINK',
  slug: 'gemini-connector'
})];
const shouldShowAiEssentialsHeros = (collectionSlug, currentPath) => collectionSlug === 'ai-essentials' && !!matchPath(currentPath, {
  path: Paths.FEATURED_COLLECTION,
  exact: true
});
const filterHeroItemsByPath = (items, currentPath) => items.filter(item => matchPath(currentPath, {
  path: item.path,
  exact: true
}));
export function useHeroData() {
  const currentMatch = useRouteMatch();
  const {
    collectionSlug
  } = useParams();
  const heroItems = useMemo(() => {
    if (!(currentMatch !== null && currentMatch !== void 0 && currentMatch.path)) {
      return [];
    }
    const allItems = [...getHeroItems()];
    if (shouldShowAiEssentialsHeros(collectionSlug, currentMatch.path)) {
      allItems.push(...getAiEssentialsHeroItems());
    }
    return filterHeroItemsByPath(allItems, currentMatch.path);
  }, [currentMatch === null || currentMatch === void 0 ? void 0 : currentMatch.path, collectionSlug]);
  return {
    heroItems,
    loading: false,
    error: undefined
  };
}